import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import Eyebrow from "../shared/Eyebrow";
import RevealText from "../shared/RevealText";
import { buildWhyUs } from "../../data/audiences";
import { useBrand } from "../../context/SiteSettingsContext";
import { viewport } from "../../lib/motion";

export default function WhyChooseUs() {
  const brand = useBrand();
  const WHY_US = buildWhyUs(brand);

  return (
    <section className="bg-ink py-24 md:py-32" data-testid="why-choose-us">
      <div className="container-emilio">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <Eyebrow>Why Choose Us</Eyebrow>
            <RevealText
              as="h2"
              text={"Professional service.\nComplete peace of mind."}
              className="mt-4 font-display font-extrabold text-white text-display"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-charcoal/70 border border-charcoal/70">
          {WHY_US.map((w, i) => {
            const Icon = Icons[toPascal(w.icon)] || Icons.CheckCircle;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={viewport}
                transition={{ duration: 0.7, delay: i * 0.05 }}
                className="bg-ink p-8 md:p-10 flex flex-col"
              >
                <div className="w-11 h-11 border border-emerald/40 grid place-items-center mb-6 group-hover:bg-emerald/10 transition-colors">
                  <Icon className="w-5 h-5 text-emerald" />
                </div>
                <div className="text-eyebrow font-display font-bold uppercase tracking-[0.22em] text-emerald mb-3">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="font-display font-bold text-white text-xl md:text-2xl leading-tight">
                  {w.title}
                </h3>
                <p className="mt-3 text-mutedtext text-sm md:text-[15px] leading-relaxed">
                  {w.body}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function toPascal(kebab) {
  return kebab
    .split("-")
    .map((s) => s[0].toUpperCase() + s.slice(1))
    .join("");
}
